import { Component } from '@opten/compiler/metadata/component';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { ProductImageSlider } from './product-image-slider';

@Component({ className: 'js-modal' })
export class ModalComponent {
	private overlay: HTMLElement;
	sliderInstance: ProductImageSlider;

	constructor(private element: HTMLElement) {
		const modal = document.querySelector(this.element.getAttribute('href'));
		if (modal) {
			this.overlay = modal.querySelector('.js-modal-overlay');
			this.element.addEventListener('click', $event => {
				$event.preventDefault();
				this.open();
			});

			modal.addEventListener(
				'close',
				e => {
					e.preventDefault();
					e.stopPropagation();
					e.stopImmediatePropagation();
					MicroModal.close(modal.id);
				},
				{ once: true }
			);
		}
	}

	private open() {
		if (this.element.getAttribute('href')) {
			const scrollTiopPosition = window.pageYOffset;
			MicroModal.show(this.element.getAttribute('href').replace('#', ''), {
				allowTouchMove: el => el.tagName === 'INPUT',
				onShow: modal => {
					const slider = modal.querySelector('.js-product-image-slider');
					if (slider) {
						const index = this.element.parentElement.getAttribute('data-index');
						this.sliderInstance = new ProductImageSlider(slider as HTMLElement, true, +index);
					}
					disableBodyScroll(this.overlay);
				},
				onClose: modal => {
					if (this.sliderInstance) {
						this.sliderInstance.destroy();
					}
					enableBodyScroll(this.overlay);
					window.scrollTo(0, scrollTiopPosition);
				}
			});
		}
	}
}
